import { render, staticRenderFns } from "./CallWidgetContainer.vue?vue&type=template&id=6120c833&"
import script from "./CallWidgetContainer.vue?vue&type=script&lang=js&"
export * from "./CallWidgetContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports